























































































































import { Component, Prop } from "vue-property-decorator"
import { parseISO, format, parseJSON, startOfToday, endOfToday } from "date-fns"
import Super from "@/pv4-super-class"
import ModalHeader from "@/components/ModalHeader.vue"
import { capitalize, find } from "lodash"

@Component({ components: { ModalHeader } })
export default class TaskReview extends Super {
  @Prop({ type: Number, required: true }) taskId!: number

  saved = true
  task: any = {}
  dependentTask: any = {}
  accounts: any = []

  setUnsaved() {
    this.saved = false
  }

  /**
   * Retrieve a user object by user ID
   */
  userByID(userID: number | string) {
    if (!this.accounts) return null
    return find(this.accounts, { userID })
  }

  mounted() {
    this.load()
  }

  /**
   * Load Task from API
   */
  load() {
    this.http
      .get(`/task/${this.taskId}?eventID=${this.eventId}`)
      .then(res => (this.task = res.data))
      .then(task => {
        // TODO: Return dependent task details in backend
        if (task.taskDependencyID) {
          return this.http
            .get(`/task/${task.taskDependencyID}?eventID=${this.eventId}`)
            .then(res => (this.dependentTask = res.data))
        }
      })
      .catch(this.displayError)

    this.http.get(`/account/all`).then(res => (this.accounts = res.data))
  }

  /**
   * Save Edited Task
   */
  save() {
    const data = {
      ...this.task
    }

    delete data.taskDueDate

    this.http
      .put(`/task/${this.taskId}?eventID=${this.eventId}`, data)
      .then(this.back)
      .catch(this.displayError)
  }

  /**
   * Format timestamp to human-readable
   */
  formatTimestamp(timestamp: string): string {
    return format(parseISO(timestamp), "dd MMM yyyy")
  }

  /**
   * Toggle task as completed or uncompleted
   */
  toggleComplete() {
    this.setUnsaved()
    this.task.taskStatus = this.task.taskStatus == 0 ? 1 : 0
  }

  /**
   * Convert user.name to User Name- remove period and capitalise first and last name
   * @param samName
   * @returns {string}
   */
  namify(samName: string): string {
    const [firstname, lastname] = samName.split(".")
    return `${capitalize(firstname)} ${capitalize(lastname)}`
  }

  /**
   * Close the modal
   */
  back() {
    this.$emit("close")
  }

  /**
   * Return a boolean true if the task is overdue, else false
   */
  get isTaskOverDue() {
    return (
      parseJSON(this.task.taskDueDate) < endOfToday() &&
      parseJSON(this.task.taskDueDate) < startOfToday()
    )
  }
}
